import * as ActionTypes from '../actions/actionTypes';

const initialState = {
    errors:        [],
    notifications: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_APPLICATION_ERROR:
            return {
                ...state,
                errors: [...action.payload]
            };
        case ActionTypes.ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: [
                    {
                        ...action.notification
                    }
                ]
            };
        case ActionTypes.REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.filter(
                    notification => notification.key !== action.key
                )
            };
        default:
            return state;
    }
};
